var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dash',{attrs:{"icon":"fa fa-user-plus","titulo":"NOVOS FORNECEDORES NO MÊS","qtd":_vm.qtd,"loading":_vm.loading,"color":"#16C172"}})
}
var staticRenderFns = []

export { render, staticRenderFns }